import { identifyByHubspotUtk } from 'api/identity'
import { getStoreState } from 'config/store'
import { getEmbedId } from 'modules/embed/selectors'
import { HubspotIdentity } from 'types/auth'
import { isNilOrEmpty,warn } from 'utils'
import { getCookieValue } from 'utils/cookies'
import { broadcast } from 'utils/message'

const HUBSPOT_GATE = 'hubspot_js'

/**
 * @summary attempts to find a linked drift user by the hubspot UTK
 *
 * @param utkVisitor hubspot visitor ID
 * @param orgId drift org ID
 * @param anonymousId drift's generated anonymous ID
 * @returns email address associated with utk for orgID, otherwise null
 */
const identifyHubspotUser = async (utkVisitor, embedId, anonymousId) => {
  try {
    const { data: identifiedHubspotUser = {} } = await identifyByHubspotUtk({
      utk: utkVisitor,
      embedId: embedId,
      anonId: anonymousId
    })

    if(!identifiedHubspotUser.email) {
      return null
    }

    return {
      email: identifiedHubspotUser.email
    }
  } catch (err) {
    warn(['Failed to identify hubspot user', err])
  }
}

/**
 * @param orgId
 * @param anonymousId anonymousId generated by drift
 */
const identifyByHubspotAPI = async(embedId, anonymousId) => {
  const utkIdentity = await broadcast({
    topic:'hubspot-hsq-identity',
    message:{
      embedId: embedId,
      anonymousId: anonymousId
    }
  })

  if (!utkIdentity || !utkIdentity.data) {
    return
  }

  return utkIdentity.data
}

const HubspotIdentityProvider = {
  isEnabled: (gates = {}): boolean => !!gates[HUBSPOT_GATE],

  identify: async (anonymousId: string): Promise<HubspotIdentity> => {
    const HUBSPOT_UTK_COOKIE = 'hubspotutk'
    const embedId = getEmbedId(getStoreState())

    try {
      let hubspotUtk =
        await getCookieValue(HUBSPOT_UTK_COOKIE) ||
        await identifyByHubspotAPI(embedId,anonymousId)


      if (!hubspotUtk) {
        return
      }

      const identity = {
        utk: hubspotUtk
      }
      const identifiedUser = await identifyHubspotUser(hubspotUtk, embedId, anonymousId)

      identity['isNewUtk'] = isNilOrEmpty(identifiedUser)

      if (identifiedUser?.email){
        identity['email'] = identifiedUser.email
      }
      return identity

    } catch(err) {
      warn(['Error attempting to identify hubspot user: ',err])
    }
  }
}

export default HubspotIdentityProvider
